import { BaseIdRequiredRequest } from "../../../base/request/BaseIdRequiredRequest";
import { ClienteFincaLoteResponse } from "../response/ClienteFincaLoteResponse";

/** Request de edición de un lote. Solo edición: `id` siempre presente
 *  (`POST /terceros/lotes/save`). Constructor privado: se crea con
 *  `createFromLote()` precargando los datos del lote a editar. */
export type ClienteFincaLoteRequest = BaseIdRequiredRequest & {
  /** Nombre del lote. */
  nombreLote: string;

  /** El lote es área productiva. */
  isAreaProductiva: boolean;

  /** Id del cultivo del lote (o null si no tiene). */
  cultivoId: string | null;
};

export const fx_createClienteFincaLoteRequest = (
  lote: ClienteFincaLoteResponse,
): ClienteFincaLoteRequest => {
  return {
    cultivoId: lote.cultivo?.id ?? null,
    id: lote.id,
    isAreaProductiva: lote.isAreaProductiva,
    nombreLote: lote.nombreLote,
  };
};
